import React, {useEffect, useState} from 'react';
import {defaultErrorHandler} from '../../../context/context';
import AddButton from '../../../libs/react-components-admin/buttons/add-button';
import {TextField} from '../../../libs/react-components-admin/fields/text-like-field';
import SubSection from '../../../libs/react-components-admin/section/sub-section';
import FieldLabel from './field-label';
import FieldPlaceholder from './field-placeholder';
import FieldHelpText from './field-help-text';
import FieldMandatory from './field-mandatory';
import FieldWidth from './field-width';
import ConditionId from './condition-id';
import DeleteButton from '../../../libs/react-components-admin/buttons/delete-button';

const PromotionalCode = ({id, conditions, value, onChange}) => {

  const [model, setModel] = useState(value);

  useEffect(() => onChange(model), [model]);

  return <>
    <FieldLabel value={model.label}
                onChange={v => setModel({...model, label: v})}/>
    <FieldPlaceholder value={model.placeholder}
                      onChange={v => setModel({...model, placeholder: v})}/>
    <FieldHelpText value={model.helpText}
                   onChange={v => setModel({...model, helpText: v})}/>
    <ValidValuesContainer value={model.validValues}
                          onChange={v => setModel({...model, validValues: v})}/>
    <FieldMandatory id={id}
                    value={model.mandatory}
                    onChange={v => setModel({...model, mandatory: v})}
                    conditionallyDisplayed={!!model.conditionId}/>
    <FieldWidth value={model.widthInPercent}
                onChange={v => setModel({...model, widthInPercent: v})}/>
    <ConditionId id={id}
                 conditions={conditions}
                 value={model.conditionId}
                 onChange={v => setModel({...model, conditionId: v})}/>
  </>;
};

export default PromotionalCode;

const ValidValuesContainer = ({value, onChange}) => {

  const [model, setModel] = useState(value || {});

  useEffect(() => onChange(model), [model]);

  return <SubSection title="List of valid codes">
    <ValidValues className="mb-3"
                 value={model.values}
                 onChange={v => setModel({...model, values: v})}/>
    <TextField label="Error message"
               helpBlock="Displayed when a form is submitted with an invalid promotional code"
               value={model.errorMessage}
               onChange={v => setModel({...model, errorMessage: v})}/>
  </SubSection>;
};

const ValidValues = ({className, value, onChange}) => {

  const [model, setModel] = useState(value || []);

  useEffect(() => onChange(model.filter(v => !!v)), [model]);

  return <ul className={className + ' list-group'}>
    {model.map((validValue, i) => <li key={i} className="list-group-item">
      <div className="row">
        <div className="col">
          <TextField noMargin={true}
                     value={validValue}
                     onChange={v => setModel(model.map((old, j) => j === i ? v : old))}/>
        </div>
        <div className="col-auto">
          <DeleteButton skipConfirmation={true}
                        action={() => setModel(model.filter((v, j) => j !== i))}
                        errorHandler={defaultErrorHandler}/>
        </div>
      </div>
    </li>)}
    <li className="list-group-item">
      <div className="row">
        <div className="col"></div>
        <div className="col-auto">
          <AddButton action={() => setModel([...model, ''])}
                     errorHandler={defaultErrorHandler}>
            {model.length === 0 ? 'Add a code' : null}
          </AddButton>
        </div>
      </div>
    </li>
  </ul>;
};
